export const baseurl = 'https://aawsat.com/';
export const defaultimage = 'https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13';
export const defaultprofileimage = 'https://static.srpcdigital.com/styles/large/public/2022-06/Logo-Asharq-07062022.jpg?itok=Z47SDY13';
export const appId = '374745497486996';
export const clientId_google = '717375500993-tdfj1a2uaf96llfjt4ff71ag9rs98mfm.apps.googleusercontent.com';
